"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var toggleLabel = "Use the same font for all text";
var showLabel = "Show font pairings";
var stopPropagation = function (e) {
    e.stopPropagation();
};
var BrandFontsHeader = function (props) {
    var brandStore = props.brandStore, fontService = props.fontService, children = props.children;
    var useSameFont = brandStore.useSameFont, toggleSameFont = brandStore.toggleSameFont;
    var onClickRecommendedFontPairs = function () {
        fontService.showPairs().then(function (selectedFonts) {
            brandStore.updateFonts(selectedFonts);
        });
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "brand-fonts-header__row" },
            react_1.default.createElement("div", { className: "brand-fonts-header__label" }, children),
            react_1.default.createElement("div", { className: "brand-fonts-header__toggle-button brand-fonts-header__toggle-button-inline", onClick: stopPropagation },
                react_1.default.createElement(kaleidoscope_1.Toggle, { label: toggleLabel, value: useSameFont, onChange: toggleSameFont })),
            react_1.default.createElement("div", { className: "brand-fonts-header__pairs-button", onClick: stopPropagation },
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: onClickRecommendedFontPairs }, showLabel))),
        react_1.default.createElement("div", { className: "brand-fonts-header__row" },
            react_1.default.createElement("div", { className: "brand-fonts-header__toggle-button", onClick: stopPropagation },
                react_1.default.createElement(kaleidoscope_1.Toggle, { label: toggleLabel, value: useSameFont, onChange: toggleSameFont })))));
};
exports.default = (0, mobx_react_1.observer)(BrandFontsHeader);
